export default __webpack_public_path__ + "84ddc3462980801cefb33b4ba05664ca.svg";